import { render, staticRenderFns } from "./TifSitiosExport.vue?vue&type=template&id=0c421f75"
import script from "./TifSitiosExport.vue?vue&type=script&lang=js"
export * from "./TifSitiosExport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports